import { s, c } from '../val.config';

const benefitSchema = s
  .object({
    title: s.string(),
    text: s.richtext({
      bold: true,
      italic: true,
      lineThrough: true,
      h1: true,
      h2: true,
      h3: true,
      h4: true,
      h5: true,
      h6: true,
      ul: true,
      ol: true,
      a: true,
      img: true,
    }),
    image: s.image(),
  })
  .preview(({ val }) => {
    return {
      title: val.title,
      image: val.image,
    };
  });

export const schema = s.record(benefitSchema);

export default c.define('/data/benefits.val.ts', schema, {
  vårjobb: {
    title: 'Dette kan du forvente med vårjobb i Blank',
    image: {
      path: '/public/val/images/fd9758e8ec515b48758ee2a92b0a4a9ec3feceb9-772x538.webp',
      width: 772,
      height: 538,
      mimeType: 'image/webp',
    },
    text: [
      {
        tag: 'p',
        children: [
          'Du vil få fri tilgang til Blank sitt kontor ved Youngstorget i Oslo hvor vi stiller med det av utstyr du måtte trenge. Designere, teknologer og produktledere fra Blank vil selvsagt være tilgjengelige for både sparring og veiledning.  ',
        ],
      },
      {
        tag: 'p',
        children: [
          'Det skjer alltid noe sosialt og gøy i Blank, som det bare er å bli med på når du vil. ',
        ],
      },
    ],
  },
  betingelser: {
    title: `Betingelser og slikt`,
    image: {
      path: '/public/val/images/d839bd22e6d63385858240fddbc5dfc89a7f7f8b-1638x1027.webp',
      width: 1638,
      height: 1027,
      mimeType: 'image/webp',
    },
    text: [
      {
        tag: 'ul',
        children: [
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: ['Vi praktiserer åpen lønn (helt på ordentlig)'],
              },
            ],
          },
          {
            tag: 'li',
            children: [
              { tag: 'p', children: ['Du får være med å drive selskapet'] },
            ],
          },
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Du får være med å velge hvilke oppdrag du skal jobbe på',
                ],
              },
            ],
          },
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Du blir del av et særdeles sterkt fagmiljø med veldig stor takhøyde',
                ],
              },
            ],
          },
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Alle som begynner i Blank får aksjer og blir medeiere',
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  ansatt: {
    title: 'Dette får du hos oss',
    image: {
      path: '/public/val/images/c5b6b478301b3c949a36c2707d2130977e9677ce-1600x962.webp',
      width: 1600,
      height: 962,
      mimeType: 'image/webp',
      hotspot: { x: 0.27182880013068694, y: 0 },
    },
    text: [
      {
        tag: 'ul',
        children: [
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Frihet og autonomi til å ta beslutninger – både for innkjøp, prosjekter og påvirke Blanks utvikling',
                ],
              },
            ],
          },
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Høy fastlønn i en åpen lønnsmodell, aksjebonus, god pensjon og bra forsikringer',
                ],
              },
            ],
          },
          {
            tag: 'li',
            children: [
              { tag: 'p', children: ['Medeierskap gjennom aksjeordninger'] },
            ],
          },
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Sterkt faglig og sosialt fellesskap hvor vi oppriktig bryr oss om hverandre',
                ],
              },
            ],
          },
          {
            tag: 'li',
            children: [
              { tag: 'p', children: ['Ekstra fri mellom jul og nyttår'] },
            ],
          },
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Du får være med å velge hvilke oppdrag du skal jobbe på',
                ],
              },
            ],
          },
          {
            tag: 'li',
            children: [
              {
                tag: 'p',
                children: [
                  'Kontor på loftet Youngstorget - som du også kan låne når du vil',
                ],
              },
            ],
          },
        ],
      },
      {
        tag: 'p',
        children: [
          { tag: 'br' },
          'Les mer om hvordan ting fungerer i Blank i ',
          {
            tag: 'a',
            href: '/handboka',
            children: ['håndboka'],
          },
          '.',
        ],
      },
    ],
  },
});
